import { useContext } from 'react';
import type { ProductContextValue } from '@/types';
import { ProductContext } from './productContext';

export function useProduct(): ProductContextValue {
  const context = useContext(ProductContext);
  if (!context) {
    throw new Error('useProduct must be used within a ProductProvider');
  }
  return context;
}
